import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=e19c903c&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=e19c903c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19c903c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e19c903c')) {
      api.createRecord('e19c903c', component.options)
    } else {
      api.reload('e19c903c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=e19c903c&scoped=true&", function () {
      api.rerender('e19c903c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/blockChain/detail.vue"
export default component.exports